import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 3.75a3 3 0 1 0 6 0 3 3 0 1 0-6 0m7 16.5a3 3 0 1 0 6 0 3 3 0 1 0-6 0m-14 0a3 3 0 1 0 6 0 3 3 0 1 0-6 0"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 6.75V8.5A3.5 3.5 0 0 1 8.5 12 3.5 3.5 0 0 0 5 15.5v1.75m7-10.5V8.5a3.5 3.5 0 0 0 3.5 3.5 3.5 3.5 0 0 1 3.5 3.5v1.75"
    }, null, -1)
  ]));
}
const interfaceHierarchyFlowchart = { render };
export {
  interfaceHierarchyFlowchart as default,
  render
};
//# sourceMappingURL=interface-hierarchy-flowchart.svg.js.map
